// Action types
export const FETCH_INTERNAL_ADMINS = 'zen/InternalAdminsTab/FETCH_INTERNAL_ADMINS';
export const FETCH_INTERNAL_ADMINS_SUCCEEDED = 'zen/InternalAdminsTab/FETCH_INTERNAL_ADMINS_SUCCEEDED';
export const FETCH_INTERNAL_ADMINS_FAILED = 'zen/InternalAdminsTab/FETCH_INTERNAL_ADMINS_FAILED';
export const SET_FILTER_TERM = 'zen/InternalAdminsTab/SET_FILTER_TERM';
export const HANDLE_SORT_CHANGE = 'zen/InternalAdminsTab/HANDLE_SORT_CHANGE';
export const UPDATE_PAGINATED_TABLE_DATA = 'zen/InternalAdminsTab/UPDATE_PAGINATED_TABLE_DATA';
export const EDIT_INTERNAL_ADMIN = 'zen/InternalAdminsTab/EDIT_INTERNAL_ADMIN';
export const CLEAR_STATE = 'zen/InternalAdminsTab/CLEAR_STATE';

const initialState = {
  internalAdminUsers: [],
  paginatedUsers: [],
  isFetching: false,
  error: null,
  sortBy: 'username',
  sortOrder: 'asc',
  filterTerm: '',
  selectedPageNumber: 1,
  elementsPerPage: 50,
  totalRecords: 0,
  totalTablePages: 0,
  fromPageCount: 0,
  toPageCount: 0,
  startPaginationRange: 0,
  endPaginationRange: 0,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_INTERNAL_ADMINS:
      return {
        ...state,
        isFetching: true,
        error: null
      };

    case FETCH_INTERNAL_ADMINS_SUCCEEDED:
      return {
        ...state,
        isFetching: false,
        internalAdminUsers: action.payload || [],
        error: null
      };

    case FETCH_INTERNAL_ADMINS_FAILED:
      return {
        ...state,
        isFetching: false,
        error: action.payload || 'Failed to fetch Internal Admins'
      };

    case SET_FILTER_TERM:
      return {
        ...state,
        filterTerm: action.payload,
        selectedPageNumber: 1
      };

    case HANDLE_SORT_CHANGE:
      return {
        ...state,
        sortBy: action.payload.sortBy,
        sortOrder: action.payload.sortOrder,
        selectedPageNumber: 1
      };

    case UPDATE_PAGINATED_TABLE_DATA:
      return {
        ...state,
        paginatedUsers: action.payload.paginatedUsers,
        selectedPageNumber: action.payload.selectedPageNumber,
        elementsPerPage: action.payload.elementsPerPage,
        totalRecords: action.payload.totalRecords,
        totalTablePages: action.payload.totalTablePages,
        fromPageCount: action.payload.fromPageCount,
        toPageCount: action.payload.toPageCount,
        startPaginationRange: action.payload.startPaginationRange,
        endPaginationRange: action.payload.endPaginationRange,
        ...(action.payload.sortBy && { sortBy: action.payload.sortBy }),
        ...(action.payload.sortOrder && { sortOrder: action.payload.sortOrder }),
      };

    case EDIT_INTERNAL_ADMIN:
      // Action for edit - details would be handled in sagas
      return state;

    case CLEAR_STATE:
      return initialState;

    default:
      return state;
  }
}

// Action creators
export function fetchInternalAdmins() {
  return {
    type: FETCH_INTERNAL_ADMINS
  };
}

export function fetchInternalAdminsSucceeded(users) {
  return {
    type: FETCH_INTERNAL_ADMINS_SUCCEEDED,
    payload: users
  };
}

export function fetchInternalAdminsFailed(error) {
  return {
    type: FETCH_INTERNAL_ADMINS_FAILED,
    payload: error
  };
}

export function setFilterTerm(filterTerm) {
  return {
    type: SET_FILTER_TERM,
    payload: filterTerm
  };
}

export function handleSortChange(sortBy, sortOrder) {
  return {
    type: HANDLE_SORT_CHANGE,
    payload: { sortBy, sortOrder }
  };
}

export function updatePaginatedTableData(tableData) {
  return {
    type: UPDATE_PAGINATED_TABLE_DATA,
    payload: tableData
  };
}

export function editInternalAdmin(user) {
  return {
    type: EDIT_INTERNAL_ADMIN,
    payload: user
  };
}

export function clearState() {
  return {
    type: CLEAR_STATE
  };
}
